import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse, Button } from 'react-bootstrap';

import './Options.sass';

function Options({
  options = [],
  selectedOptions = [],
  onSave = null,
  title = 'Options',
  onChange,
}) {
  const [opened, setOpened] = useState(false);
  const save = () => {
    // save the columns for the table
    onSave();
    // close the options checkboxes
    setOpened(false);
  };
  return (
    <div className="options">
      <div className="options-buttons">
        <Button onClick={() => setOpened(!opened)}>
          {opened ? 'Close' : title}
        </Button>
        {opened && (
          <Button variant="warning" onClick={save}>
            Save
          </Button>
        )}
      </div>
      <Collapse in={opened}>
        <div className="options-content">
          {options.map(({ key, title: t }) => (
            <div key={key} style={{ width: '50%' }}>
              <label style={{ width: '100%' }}>
                <input
                  type="checkbox"
                  onChange={(e) => onChange(e.target.name)}
                  checked={selectedOptions.includes(key)}
                  name={key}
                />
                {` ${t}`}
              </label>
            </div>
          ))}
        </div>
      </Collapse>
    </div>
  );
}

Options.propTypes = {
  selectedOptions: PropTypes.array,
  onSave: PropTypes.array,
  title: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
};

export default Options;
